import Sermons from './Sermons';

export default Sermons;
